import styled from 'styled-components'

export const Name = styled.h3`
  font-weight: 500;
  margin: 0px;
  text-align: center;
  padding: 0px 20px;

  font-size: 28px;
  line-height: 32px;

  @media(min-width: 768px){
    text-align: left;
    padding: 0px;
    font-weight: 600;
  }
`

export const CongratsText = styled.p`
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  text-align: center;
  padding: 0px 20px;
  width: 100%;

  @media(min-width: 768px){
    text-align: left;
    padding: 0px;
    font-size: 22px;
    line-height: 26px;
    width: auto;
  }
`

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
`

export const CategoryHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start; 
  gap: 14px;
  width: 100%;
  flex-direction: column;

  @media(min-width: 768px){
    flex-direction: row;
    align-items: center;
    justify-content: space-between; 
  }
`
